import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as stageResponse from '../../types/stage-response';
import { Observable } from 'rxjs/Rx';
import * as _ from 'lodash';
import { WindowRefService } from '../../../shared/services/window-ref.service';
import { BaseFileTypeComponent } from '../base-file-type/base-file-type.component';

@Component({
  selector: 'tr-doc-confirmation',
  templateUrl: './doc-confirmation.component.html',
  //styleUrls: ['./doc-confirmation.component.scss']
})
export class DocConfirmationComponent extends BaseFileTypeComponent<stageResponse.IHtmlElement> {
  //@Input() document: ;
  //@Input() viewedDocStatus$: Observable<boolean>;
  //@Input() confirmedDocStatus$: Observable<boolean>;
  //@Input() isDownloading$: Observable<boolean>;
  //@Input() currentAction$: Observable<string>;
  //@Output() documentAction= new EventEmitter<string>();

  constructor(private windowRef: WindowRefService) {
    super(windowRef);
  }

  getIco(name: string, isViewed:boolean): string {
    let cls = `ico-${name.toLowerCase()}`;
    if (name.toLowerCase() === 'view') {
      if (!isViewed) {
        cls += ' pulse infinite ';
      }
    }
    return cls;
  }

  getTitle(): string {
    if (_.has(this.componentDef, 'showname') && this.componentDef.showname) {
      return this.componentDef.name.substring(0, this.componentDef.name.lastIndexOf('.'));
    } else {
      return this.componentDef.title;
    }
  }

  onConfirmClicked($event) {
    $event.preventDefault();
    if (this.componentDef.confirmed) {
      return false;
    } else {
      alert(this.componentDef.confirm.href);
    }
  }

  shortenTitle (title: string): string {
    let shortenTitleName = title;
    if (title.length > 20) {
      shortenTitleName = title.substring(0,15)+"...";
    }
    
    return shortenTitleName;
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/components/doc-confirmation/doc-confirmation.component.ts